export default "__VITE_ASSET__Dj3Iw04N__"